import { render } from "./CounterVote.vue?vue&type=template&id=aafa253c"
import script from "./CounterVote.vue?vue&type=script&lang=js"
export * from "./CounterVote.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__